import Image, { StaticImageData } from 'next/image';
import type React from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

type MoviePartnerProps = {
    className?: string;
    title: string;
    url: string;
    logo?: string | StaticImageData;
    logoAlt: string;
    customImage?: React.ReactNode;
};

function MoviePartner(props: MoviePartnerProps) {
    const { className, title, url, logo, logoAlt, customImage } = props;
    return (
        <div className={cn(className)}>
            <a
                className={cn('relative flex flex-col overflow-hidden gap-y-8')}
                href={url}
                target="_blank"
                rel="noreferrer">
                <div className="text-body-10">{title}</div>
                <div className="relative h-32">
                    {customImage}
                    {!customImage && logo && (
                        <Image
                            className="w-auto h-full"
                            src={logo}
                            blurDataURL={typeof logo === 'string' ? logo : logo.src}
                            width={200}
                            height={200}
                            alt={logoAlt}
                        />
                    )}
                </div>
            </a>
        </div>
    );
}

export default MoviePartner;
